import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// IMPORTANT: NO llamamos snapSaveState explícitamente.
// react-snap toma el snapshot cuando pasa el `waitFor` configurado en package.json
// (5000ms). Si llamáramos snapSaveState acá, se dispararía a los 800ms y react-snap
// tomaría snapshot ANTES de que los useEffect terminen sus fetches → HTMLs sin datos
// (ej. fichas de centros con `<title>undefined - Centro...</title>`).

// Si hay contenido pre-renderizado, usar hydrate; sino, usar render normal
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
